enum ACTIONS {
    FETCH_ALL_VACANCIES = 'FETCH_ALL_VACANCIES_V2',

    CREATE_VACANCY = '[VACANCY] - CREATE',
    CREATE_VACANCY_VALUES = '[VACANCY] - CREATE VALUES',
    BACKGROUND_CREATE_VACANCY_VALUES = '[VACANCY][BACKGROUND] CREATE VALUES',

    FETCH_ALL_VACANCYS = 'FETCH_ALL_VACANCYS_V2',
    FETCH_VACANCY = 'FETCH_VACANCY_V2',
    FETCH_VACANCY_VALUES = 'FETCH_VACANCY_VALUES',
    FETCH_VACANCIES_VALUES = 'FETCH_VACANCYS_VALUES',
    FETCH_VACANCY_CONCEPT = 'FETCH_VACANCY_CONCEPT',
    FETCH_VACANCY_OVERVIEW_PAGE = '[VACANCY] Overview page',

    
    UPDATE_VACANCY = '[VACANCY] UPDATE',
    UPDATE_VACANCY_VALUES = '[VACANCY] UPDATE VALUES',
    BACKGROUND_UPDATE_VACANCY_VALUES = '[VACANCY][BACKGROUND] UPDATE VALUES',
    UPSERT_VACANCY_VALUES = '[VACANCY] UPSERT VALUES',
    SAVE_VACANCY_VALUES = 'SAVE_VACANCY_VALUES',

    DELETE_VACANCY = '[VACANCY] - DELETE'
}

export default ACTIONS;

export enum CREATE_VACANCY {
    REQUEST = 'CREATE_VACANCY_REQUEST',
    SUCCESS = 'CREATE_VACANCY_SUCCESS',
    FAILURE = 'CREATE_VACANCY_FAILURE'
}

export enum FETCH_ALL_VACANCY {
    REQUEST = 'FETCH_ALL_VACANCY_REQUEST',
    SUCCESS = 'FETCH_ALL_VACANCY_SUCCESS',
    FAILURE = 'FETCH_ALL_VACANCY_FAILURE'
}

export enum FETCH_VACANCY {
    REQUEST = 'FETCH_VACANCY_REQUEST',
    SUCCESS = 'FETCH_VACANCY_SUCCESS',
    FAILURE = 'FETCH_VACANCY_FAILURE'
}

export enum SAVE_VACANCY {
    REQUEST = 'SAVE_VACANCY_REQUEST',
    SUCCESS = 'SAVE_VACANCY_SUCCESS',
    FAILURE = 'SAVE_VACANCY_FAILURE'
}

export enum SAVE_VACANCY_STATUS {
    REQUEST = 'SAVE_VACANCY_STATUS_REQUEST',
    SUCCESS = 'SAVE_VACANCY_STATUS_SUCCESS',
    FAILURE = 'SAVE_VACANCY_STATUS_FAILURE'
}

export enum VACANCY {
    EDIT = 'VACANCY_EDIT',
    RESET = 'VACANCY_RESET'
}

export enum FETCH_VACANCY_DATASET {
    REQUEST = 'FETCH_VACANCY_DATASET_REQUEST',
    SUCCESS = 'FETCH_VACANCY_DATASET_SUCCESS',
    FAILURE = 'FETCH_VACANCY_DATASET_FAILURE'
}